// @flow @jsx h

import {
  SerumSmartPicture,
  SmartVideo,
  Slide
} from '@nrk/dh-feature-components'
import { bem } from '@nrk/dh-utils'
import { h } from 'preact'
// import Fallback from '../Fallback'
import style from './index.css'

import type { DefaultSlideProps } from './types'

function MediaSlide (props: DefaultSlideProps) {
  const {
    isIntersecting,
    mediaBaseUrl,
    viewport,
    parentVisible,
    ...restProps
  } = props
  const { description, media, title } = props.value

  if (!media) {
    return <Slide {...restProps} className={style.visualStory__slide} />
  }

  let text = (description || title) && (
    <div className={style.visualStory__slideText}>
      {title && <h3 dangerouslySetInnerHTML={{ __html: title }} />}
      {description && <p dangerouslySetInnerHTML={{ __html: description }} />}
    </div>
  )

  switch (media.type) {
    case 'image':
      return (
        <Slide {...restProps} className={style.visualStory__slide}>
          {text}
          <SerumSmartPicture horizontal={media} vertical={media} alt='' />
        </Slide>
      )

    case 'videoLoop':
      return (
        <Slide
          {...restProps}
          className={bem(style.visualStory__slide, {
            active: restProps.active
          })}
        >
          {text}
          <SmartVideo
            className={style.visualStory__smartVideo}
            loop
            muted
            playing={parentVisible && restProps.active}
            playsInline
            preload='none'
            resolution720p={{
              poster: `${mediaBaseUrl}${media.resolution720p.poster}`,
              sources: media.resolution720p.sources.map(source => {
                return {
                  type: source.type,
                  src: `${mediaBaseUrl}${source.src}`
                }
              })
            }}
            resolution960p={{
              poster: `${mediaBaseUrl}${media.resolution960p.poster}`,
              sources: media.resolution960p.sources.map(source => {
                return {
                  type: source.type,
                  src: `${mediaBaseUrl}${source.src}`
                }
              })
            }}
            resolution1080p={{
              poster: `${mediaBaseUrl}${media.resolution1080p.poster}`,
              sources: media.resolution1080p.sources.map(source => {
                return {
                  type: source.type,
                  src: `${mediaBaseUrl}${source.src}`
                }
              })
            }}
            viewport={viewport}
          />
        </Slide>
      )

    default:
      return <Slide {...restProps} className={style.visualStory__slide} />
  }
}

export default MediaSlide



// WEBPACK FOOTER //
// ./src/v1/components/VisualStory/MediaSlide.js